export default __webpack_public_path__ + "static/media/YAMP.57f1ddb2.svg";